import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { SeriesService } from '../../../services/index';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

@Component({
    selector: 'add-edit-series-window',
    templateUrl: './addEditSeries.component.html'
})
export class AddEditSeriesComponent implements OnInit {
    public title: string;
    public mode: string;
    public list: any[] = [];
    public seriesdata: any[] = [];
    filteredBrand: Observable<any[]>;
    brandList$: any[] = [];
    brandCtrl: FormControl;

    // trigger-variable for Ladda
    isLoading: boolean = false;
    @Output() seriesLoadEvent = new EventEmitter();

    constructor(public store: Store<fromRootStore.State>, private seriesService: SeriesService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {
        //FOR AUTO COMPLETE VALIDATION --- BRAND COMBO
        function hasValidBrand(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidBrand: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidBrand: true };
            }
            return retVal;
        }
        this.brandCtrl = new FormControl('', [
            Validators.required,
            hasValidBrand.bind(this)
        ]);
        this.filteredBrand = this.brandCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrand(name) : this.brandList$.slice());
    }

    ngOnInit(): void {
        this.store.select(fromCommonStore.getAllBrand).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandList$ = res;
                return;
            }
            this.brandList$ = res;
        });
        setTimeout(() => {
            $('#Series_name').focus();
        }, 100);
    }

    //BRAND
	filterBrand(name: string) {
		name = _.escapeRegExp(name);
		return this.brandList$.filter(item => (new RegExp(name, 'gi').test(item.name)));
	}
	displayBrandFn(brandID: number) {
		if (brandID && this.brandList$.length > 0) {
			let fitem = _.find(this.brandList$, { 'brand_id': brandID });
			return fitem['name'];
		}
		return '';
	}

    onSaveSeries(): void {
        let that = this;
        this.isLoading = true;
        this.seriesService
            .addUpdateSeries(this.seriesdata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.seriesLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/series/addEditSeries.component.ts